import { render, staticRenderFns } from "./FrontendFilterInput.vue?vue&type=template&id=70c5270c&"
import script from "./FrontendFilterInput.vue?vue&type=script&lang=ts&"
export * from "./FrontendFilterInput.vue?vue&type=script&lang=ts&"
import style0 from "./FrontendFilterInput.vue?vue&type=style&index=0&id=70c5270c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports